// Minimum age requirement for car rental drivers
export const MINIMUM_DRIVER_AGE = 18;

// Default driver age when not specified
export const DEFAULT_DRIVER_AGE = 25;
